import { Component, type ReactNode } from 'react';

/**
 * מסכים נטענים בנפרד (App.tsx). ברשת חלשה, או אחרי שגרסה חדשה פורסמה
 * והקבצים הישנים כבר אינם בשרת, טעינת מסך יכולה להיכשל. במקום מסך לבן —
 * הסבר וכפתור לטעינה מחדש. טיוטות שנשמרו אינן נפגעות מטעינה מחדש.
 */
export class ScreenBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="card" role="alert" data-testid="screen-load-failed">
        <p>
          <strong>המסך לא נטען.</strong> ייתכן שהרשת חלשה, או שפורסמה גרסה חדשה של האפליקציה.
        </p>
        <button type="button" className="btn" onClick={() => window.location.reload()}>
          טעינה מחדש
        </button>
      </div>
    );
  }
}
